import React, { MouseEvent } from "react";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { useSiteSelectorContext } from "@/components/site-selector-modal/index.ts";
import {
    Button,
    ButtonProps
} from "@/libraries/design/components/button/src/button.tsx";
import {
    useLocale,
    getLocalizedHref
} from "@/libraries/web-framework/index.ts";

export interface TemplateModalButtonProps {
    text: string;
    productKey: string;
    templateName: string;
    pluginModuleKey?: string;
    href?: string;
}

export const TemplateModalButton = (props: TemplateModalButtonProps) => {
    const { text, productKey, templateName, pluginModuleKey, href } = props;

    const { openModalForTemplate } = useSiteSelectorContext();
    const locale = useLocale();

    let buttonProps: ButtonProps = {
        href: getDefaultHref({
            productKey,
            locale
        })
    };

    const fullStargateProductKey =
        productKey === "jira-service-management"
            ? "jira-servicedesk.ondemand"
            : `${productKey}.ondemand`;

    if (pluginModuleKey && productKey) {
        buttonProps = {
            onClick: (event: MouseEvent<HTMLButtonElement>) => {
                event.stopPropagation();
                event.preventDefault();
                openModalForTemplate({
                    templateId: pluginModuleKey,
                    templateName,
                    productKey: fullStargateProductKey as ProductKeys
                });
            }
        };
    } else if (href) {
        buttonProps = {
            href: getLocalizedHref({ href, locale })
        };
    }

    return <Button {...buttonProps}>{text}</Button>;
};

interface GetDefaultHrefArgs {
    productKey: string;
    locale: string;
}
function getDefaultHref(args: GetDefaultHrefArgs) {
    const { locale, productKey } = args;

    if (productKey === "jira-software") {
        return getLocalizedHref({
            href: "/try/cloud/signup?bundle=jira&edition=free",
            locale
        });
    }
    if (productKey === "confluence") {
        return getLocalizedHref({
            href: "/try/cloud/signup?bundle=confluence&edition=free",
            locale
        });
    }
    if (productKey === "jira-service-management") {
        return getLocalizedHref({
            href: "/try/cloud/signup?bundle=jira-service-management&edition=free",
            locale
        });
    }

    return "";
}
